import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
	UntypedFormBuilder,
	FormControl,
	UntypedFormGroup,
	ValidationErrors,
	Validators,
} from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LanguageService } from '@services/public';
import { CdkStepper, StepperSelectionEvent } from '@angular/cdk/stepper';
import { StepThreeComponent } from '../step-three/step-three.component';
import { StepTwoComponent } from '../step-two/step-two.component';
const PAGE_PATH = `pages.leader.dashboard.groupManagement.createGroup`;
@Component({
	selector: 'app-create-group',
	templateUrl: './create-group.component.html',
})
export class CreateGroupComponent implements OnInit {
	@Output() submitPop: EventEmitter<any> = new EventEmitter();
	dailogTitle: string = '';
	form: UntypedFormGroup;
	activedStep = 0;
	step1 = false;
	isStepTwo: any = false;
	// Page language.
	page: { [key: string]: string } = {};
	constructor(
		private _languageSvc: LanguageService,
		public bsModalRef: BsModalRef,
		public fb: UntypedFormBuilder,
	) {}
	onStepChanged(event: any) {
		const selectedIndex = event.selectedIndex;
		const previousIndex = event.previouslySelectedIndex;
		if (previousIndex < selectedIndex) {
			// The next step was clicked, so load the next component
			if (selectedIndex === 1) {
				this.isStepTwo = true;
			}
		} else {
			if (previousIndex === 1) {
				this.isStepTwo = false;
			}
		}
	}
	ngOnInit(): void {
		this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] !== 'object' || value[PAGE_PATH] === null)
				return;
			this.page = value[PAGE_PATH];
			this.dailogTitle = this.page?.title;
			for (const key in this.page)
				this._languageSvc
					.template(this.page[key])
					.then((value) => (this.page[key] = value));
		});
	}

	onModelClose(event) {
		this.submitPop.emit(true);
		this.bsModalRef.hide();
	}
	decline() {
		this.bsModalRef.hide();
	}
}
